var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 2,
    viewBox: "0 0 4 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4727 1.54468L3.1768 0.803711C3.3394 0.632571 3.502 0.404783 3.66459 0.233643C3.66459 0.176763 3.231 0.689688 2.85209 1.03174L2.4185 1.48779C2.3101 1.6018 2.4727 1.48755 2.4727 1.54468ZM1.9307 1.11133C2.1475 1.28247 2.25591 1.51026 2.3643 1.56738C2.09379 1.28247 1.1182 0.199219 1.064 0.199219C1.0098 0.199219 1.60599 0.712398 1.9307 1.11133Z",
    fill: "#F1F6EF",
    stroke: "white",
    strokeWidth: 0.3301,
    strokeMiterlimit: 2.88692
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdown);
export default __webpack_public_path__ + "static/media/arrow-dropdown.27aff8a0314c90d7ba1c5ffd5af6594c.svg";
export { ForwardRef as ReactComponent };